import { Divider, Drawer, List, useTheme } from '@material-ui/core';
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import adminRoutesConstant from '../../../constants/adminRoutesConstant';
import { enableRoleBasedRoutes } from '../../../constants/env';
// import navMenuList from '../../../constants/navMenuList';
import Text from '../Text';

const Sidebar = ({
    openSidebar,
    setOpenSidebar,
    classes
}) => {

    const theme = useTheme();

    const [navMenuList, setNavMenuList] = React.useState([]);

    const handleDrawerClose = () => {
        setOpenSidebar(false);
    };

    const history = useHistory();
    const auth = useSelector(state => state.auth)

    const pathName = history.location.pathname;


    // const authRole = useSelector(state => state.auth.roleId)

    const setMenuListBasedOnRoles = () => {
        const dashboardUrls = (
            Object.values(adminRoutesConstant.adminPaths)
                .filter((each) => each.isShownOnSidebar)

                // filter out not permitted links
                .filter(each => {
                    if (enableRoleBasedRoutes) {
                        // if permission is "null/undefined" then dont render any links
                        if ((!auth.admin.permission)) {
                            return false
                        }
                        return ((!each.permissionKey || !each.crudType) || (auth.admin.permission && auth.admin.permission[each.permissionKey] && auth.admin.permission[each.permissionKey][each.crudType] == '1'))
                    }
                    else {
                        return true
                    }
                })

                .map(each => ({
                    icon: each.icon,
                    key: each.key,
                    title: each.label,
                    path: each.url(),
                    forRole: ["0", "1", "2", null],
                }))
        );

        setNavMenuList(dashboardUrls)
    }

    React.useEffect(() => {

        if (adminRoutesConstant && adminRoutesConstant.adminPaths) {
            setMenuListBasedOnRoles()
        }

    }, [JSON.stringify(adminRoutesConstant)])

    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: openSidebar,
                [classes.drawerClose]: !openSidebar,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: openSidebar,
                    [classes.drawerClose]: !openSidebar,
                }),
            }}
        >
            <div className={classes.toolbar}>
                <IconButton color="primary" onClick={handleDrawerClose}>
                    {theme.direction === "rtl" ? <ChevronRightIcon color='primary' /> : <ChevronLeftIcon color='primary' />}
                </IconButton>
            </div>
            <Divider />
            <List>
                {navMenuList.map((item, index) => (
                    <Link to={item.path} key={index} style={{ textDecoration: 'none' }}>
                        <ListItem button selected={pathName.includes(item.path)} className={classes.listItem} >
                            <img src={item.icon} alt='icon' className={classes.menuIcon} />
                            {openSidebar && <Text ascent='primary'>{item.title}</Text>}
                        </ListItem>
                    </Link>
                ))}
            </List>
        </Drawer>
    )
}

export default Sidebar
